import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueMeta from 'vue-meta'
// element-ui
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// datav
import dataV from '@jiaminghi/data-view'
// 全局样式
import '@/assets/style/default.scss'

Vue.config.productionTip = false
Vue.prototype.$scroll = 0;
Vue.use(VueMeta)
Vue.use(ElementUI)
Vue.use(dataV)



new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
